import { Card } from '@ui/themed';
import { t } from 'i18next';
import { Upsell } from '../../../components/upsell';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';

const SHIPPING_LEARN_MORE_URL = 'https://docs.sparklayer.io/shipping';

export function ShippingMethodsUpsell() {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const featureItems = [
    {
      key: 'methods',
      title: t(
        'features:shipping_methods.pages.shipping_methods_page.upsell.features.methods.title',
      ),
      description: t(
        'features:shipping_methods.pages.shipping_methods_page.upsell.features.methods.description',
      ),
    },
    {
      key: 'targeting',
      title: t(
        'features:shipping_methods.pages.shipping_methods_page.upsell.features.targeting.title',
      ),
      description: t(
        'features:shipping_methods.pages.shipping_methods_page.upsell.features.targeting.description',
      ),
    },
  ];

  return (
    <Card>
      <Upsell
        title={t('features:shipping_methods.pages.shipping_methods_page.upsell.title')}
        subtitle={t('features:shipping_methods.pages.shipping_methods_page.upsell.subtitle')}
        imageType="shippingMethod"
        plans={['v2_basic']}
        onClickUpgrade={() => {
          trackUpgradeClicked(site, 'Shipping');
          navigationHandler.navigateById('plan');
        }}
        onClickLearn={() => window.open(SHIPPING_LEARN_MORE_URL, '_blank', 'noopener,noreferrer')}
        details={{
          foreword: t('features:shipping_methods.pages.shipping_methods_page.upsell.intro'),
          use_cases: featureItems,
        }}
      />
    </Card>
  );
}
